export default {
  state: {
    activeProductItem: null,
    PcxPaymentTypes: [],
    RelatedBooks: [],
  },
  getters: {},
  mutations: {
    updateActiveProductItem(state, value) {
      state.activeProductItem = value;
    },
    updatePaymentTypes(state, value) {
      state.PcxPaymentTypes = value;
    },
    updateRelateBook(state, value) {
      state.RelatedBooks = value;
    }
  },
  actions: {}
};



// WEBPACK FOOTER //
// ./src/store/pcx/pcx.js